module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_all2",
    attrs: {
      "id": "account_info"
    }
  }, [_c('div', {
    staticClass: "content_box"
  }, [_c('div', {
    staticClass: "list_box2"
  }, [_c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "maroon"
    }
  }, [_c('strong', [_vm._v("主旨：提供臺大體育室戶外場地、舊體育館線上訂位系統 "), _c('br')])]), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }, [_vm._v("說明：\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("一、體育室目前所提供之「線上訂位系統」，可透過網路預約體育室戶外場地、舊體育館。\n        "), _c('br'), _vm._v("二、提供校內團體使用以解決平日排隊預約之不便，包括校內行政單位、系所學會、校隊、社團。\n        "), _c('br')]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _c('strong', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }, [_c('font', {
    attrs: {
      "color": "maroon"
    }
  }, [_vm._v("體育室「體育館及戶外場地線上訂位系統」簡介：")])], 1), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "maroon"
    }
  }, [_vm._v("一、簡介")]), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "#696969"
    }
  }, [_c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("1. 因應網際網路發達普及，校內服務亦隨之日趨網路化，許多申請查詢等等傳統式紙上作業，在校內各單位的共同努力之下，也已發展出網路版，俾能提昇工作效率，加速資訊傳遞，以及減少傳統作業的往返人力負擔。此外，以往每月二十五日學生社團為了爭取到場地使用往往徹夜排隊於舊體育館門口，為了減少借用團體精神、時間上耗損，特建構體育館線上訂位系統，俾能解決校內借用團體熬夜之苦。\n          "), _c('br'), _vm._v(" \n          "), _c('br'), _vm._v("2. 依校內行政單位、系所學會、校隊、社團等單位，給定每個已申請帳號單位固定申請數量次數，並在每個月15至20日選擇時段與場地登記抽籤，並發信通知已登記單位確認，並公佈已登記者，20日以系統亂數抽籤決定中選者，並公佈抽籤結果，發信通知抽籤結果。中籤者，七日內至舊體育館辦理登記，始完成借用手續。\n          "), _c('br')]), _vm._v(" \n      ")], 1), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "maroon"
    }
  }, [_vm._v("二、目前提供的帳號種類，列表如下：\n        "), _c('br')]), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }, [_vm._v("1. 校內行政單位 由各分會負責人提出申請 \n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("2. 校隊 由各運動代表隊隊長提出申請 \n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("3. 系所學會 由各系所會負責人提出申請 \n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("4. 社團 由各社團負責人提出申請 \n        "), _c('br')]), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "maroon"
    }
  }, [_vm._v("三、申請資格")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "#696969"
    }
  }, [_c('font', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("校內行政單位：由分會負責人申請帳號\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("運動代表隊：以運動代表隊隊長為負責人申請帳號\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("系所學會：以系所學會負責人申請帳號\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("社團：以社團負責人申請帳號")]), _vm._v(" \n      ")], 1), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "maroon"
    }
  }, [_vm._v("四、申請方式")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "#696969"
    }
  }, [_c('font', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("1. 請上網申請：填寫校內團體帳號申請書並列印 \n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("2. 攜單位章至體育室場地組確認用印後，帳號與密碼將會寄送至表格所填寫E-mail信箱")]), _vm._v(" \n      ")], 1), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "maroon"
    }
  }, [_vm._v("五、申請期限")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "#696969"
    }
  }, [_c('font', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("1、網路抽籤登記權限為一學年(自當年8/1至隔年7/31) \n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("2、請於每年6月1日至6月30日辦理新學年度申請作業(含舊帳號展延、新帳號申請) 逾期者將暫時停權。")]), _vm._v(" \n      ")], 1), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "maroon"
    }
  }, [_vm._v("六、帳號更改 若欲更換負責人資料，請填具申請書至舊體育館辦理 \n        "), _c('br')]), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "maroon"
    }
  }, [_vm._v("七、其他疑問如對臺大體育館線上訂位系統有任何建議指教，煩請跟我們聯絡：")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _c('span', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('br', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-family": "Verdana, Helvetica, sans-serif",
      "font-size": "small"
    },
    attrs: {
      "color": "#696969"
    }
  }, [_c('font', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("1. email：\n          "), _c('a', {
    attrs: {
      "href": "mailto:samurai@ntu.edu.tw"
    }
  }, [_c('font', {
    staticStyle: {
      "background-color": "inherit"
    },
    attrs: {
      "color": "#000000"
    }
  }, [_vm._v("hmchang@ntu.edu.tw")])], 1), _vm._v(" \n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("2. 電話諮詢：3366-9515\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("3. 或親臨舊體育館辦公室")]), _vm._v(" \n      ")], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71cc1e56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rent/AccountInfo.vue
// module id = 1278
// module chunks = 3